/** “1 office” vs “5 offices” for counts tied to cohort wording. */
export function officeSeoOfficesNoun(count: number): 'office' | 'offices' {
  return count === 1 ? 'office' : 'offices';
}

/** Subject–verb agreement for “N office(s) … have/has …”. */
export function officeSeoOfficesHaveVerb(count: number): 'have' | 'has' {
  return count === 1 ? 'has' : 'have';
}

/** “1 Codi client” vs “5 Codi clients”. */
export function officeSeoClientsNoun(count: number): 'client' | 'clients' {
  return count === 1 ? 'client' : 'clients';
}
